import { CartItems } from "./CartItem";
export const Cart = () => {
  return (
    <div>
      <CartItems />
    </div>
  );
};
